/* Union Sport — defer PhotoSwipe init until first interaction */
(function() {
  if (!window.theme || typeof theme.Photoswipe !== 'function') return;
  var _Orig = theme.Photoswipe;
  theme.Photoswipe = function($container, sectionId) {
    var _instance = null;
    $container.on('mouseenter touchstart', '.photoswipe__image', function() {
      if (!_instance) {
        _instance = new _Orig($container, sectionId);
      }
    });
  };
})();